<template>
  <div>
    <modal v-if="isPromptOpen" :status="isPromptOpen">
      <h2>Setup</h2>
      <form @submit.prevent="loadSessions" class="">
        <TextInput
          :key="userId"
          class="col"
          label="Username"
          name="username"
          disabled
          :value="username"
        />
        <DatePicker class="col" autoFocus label="Date" name="date" v-model="resultDate" />
        <SelectInput
          class="col"
          label="Queue-up all cases for Re-Screen"
          name="reScreen"
          v-model="reScreen"
          :items="yesNoOptions"
        />
        <div class="d-flex pt-1 self-">
          <button type="submit" class="btn btn-primary ml-auto">Submit</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import eventBus, { CYTOLOGY_SESSION_PROMPT } from "@/modules/eventBus";
import { mapState } from "vuex";

export default {
  name: "CytologySetupPopup",

  components: {
    Modal: () => import("@/components/common/Modal.vue"),
    TextInput: () => import("@/components/common/TextInput.vue"),
    DatePicker: () => import("@/components/common/DatePicker.vue"),
    SelectInput: () => import("@/components/common/SelectInput.vue")
  },
  mounted() {},
  domStreams: ["$promptEvent"],
  data() {
    return {
      isReportPopupOpen: false,
      yesNoOptions: [
        {
          id: true,
          displayName: "Yes"
        },
        {
          id: false,
          displayName: "No"
        }
      ]
    };
  },
  methods: {
    loadSessions() {
      eventBus.$emit(CYTOLOGY_SESSION_PROMPT, {
        resultedBy: this.username,
        resultedOn: this.resultDate,
        isRescreen: this.reScreen
      });
      this.$store.commit("sessionDetails/toggleCytologyPrompt");
    }
  },
  computed: {
    ...mapState({
      cytologyPrompted: state => state.sessionDetails.cytologyPrompted,
      currentUser: state => state.currentUser,
      sessionResultDate: state => state.sessionDetails.resultedOnDate,
      isPromptOpen: state => state.sessionDetails.cytologyPrompt
    }),
    // User identification
    username() {
      return this.currentUser?.lastName + ", " + this.currentUser?.firstName;
    },

    userId() {
      return this.$store.state.currentUser.id;
    },

    resultDate: {
      get() {
        return this.sessionResultDate;
      },
      set(val) {
        this.$store.commit("sessionDetails/setResultedOnDate", val);
      }
    },
    reScreen: {
      get() {
        return this.$store.state.sessionDetails.reScreen;
      },
      set(value) {
        this.$store.commit("sessionDetails/setRescreening", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
